import React from 'react';
import { useTranslation } from 'react-i18next';
import { AddVariableInContentTextRichEditor } from '../RichEditor/utils';
import { useInsertionTarget } from './insertionTarget';
import InsertionControls from '../common/InsertionControls';
import BoxFormControlsPortal from '../RightSide/BoxFormControlsPortal';

/* Raccourcis d'insertion (emoji / variable texte / image) pour l'édition d'une
   cellule ou d'un en-tête de tableau. Même mécanique que la section
   « insertion » de TextStylingComponent (wrap=true), mais isolée : la cellule
   garde son style via FloatyTextStyling (barre flottante), et n'a pas de
   textStyle de box pour la section « Style du texte » que wrap=true imposerait. */
const CellInsertionPanel = ({ editorState, setEditorState, setDefaultSelection, hasImage = true, order, inactive = false }) => {
  const { t } = useTranslation();

  const handleAddAt = () => setEditorState(AddVariableInContentTextRichEditor(editorState, ' @'));
  const handleAddImageVariable = () => {
    setEditorState(AddVariableInContentTextRichEditor(editorState, ' /'));
    setDefaultSelection?.('img');
  };

  return (
    <BoxFormControlsPortal title={t('insertion')} order={order}>
      {/* Le marqueur garde la cellule en édition (cf. useCellClickOutside), le
          preventDefault lui garde le focus : l'insertion tombe au curseur et
          on continue à taper sans recliquer dans la cellule.
          Cellule plus active (le temps de passer à une autre) : la section reste
          affichée sans clignoter, mais n'insère plus rien. */}
      <div
        data-cell-insertion="true"
        onMouseDown={(e) => e.preventDefault()}
        style={inactive ? { pointerEvents: 'none' } : undefined}
      >
        <InsertionControls
          editorState={editorState}
          setEditorState={setEditorState}
          onAddAt={handleAddAt}
          onAddImage={handleAddImageVariable}
          hasImage={hasImage}
        />
      </div>
    </BoxFormControlsPortal>
  );
};

// Section « Insertion » unique du tableau `boxId`, branchée sur l'éditeur que la
// cellule ou l'en-tête sélectionné a déclaré (cf. insertionTarget).
export const TableInsertionPanel = ({ boxId, order = 0 }) => {
  const target = useInsertionTarget();
  if (!target || target.boxId !== boxId) return null;
  return (
    <CellInsertionPanel
      editorState={target.editorState}
      setEditorState={target.setEditorState}
      setDefaultSelection={target.setDefaultSelection}
      hasImage={target.hasImage}
      inactive={!target.active}
      order={order}
    />
  );
};

export default CellInsertionPanel;
